import { useIsMobile } from "@/hooks/use-mobile";

interface DesktopTopbarProps {
  currentTab: string;
}

// Mapeamento de IDs das abas para nomes amigáveis
const tabNames: Record<string, string> = {
  dashboard: "Dashboard",
  accounts: "Contas",
  "credit-cards": "Cartões",
  transactions: "Transações",
  goals: "Metas",
  reports: "Relatórios",
  settings: "Configurações",
  categories: "Categorias",
};

export const DesktopTopbar = ({ currentTab }: DesktopTopbarProps) => {
  const isMobile = useIsMobile();
  
  // Não renderizar no mobile
  if (isMobile) {
    return null;
  }
  
  const tabName = tabNames[currentTab] || currentTab;
  
  return (
    <div className="h-16 bg-background flex items-center px-6 w-full">
      <h1 className="text-xl font-semibold text-foreground">
        {tabName}
      </h1>
    </div>
  );
};
